export default __webpack_public_path__ + "static/Blind-angels-dazon-profile_mobile-eb912ad717241b8b0fc4efa1796645d0.png";